import React, { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import WhoCountryMappingTab from './WhoCountryMappingTab';
import WhoIndicatorMappingTab from './WhoIndicatorMappingTab';
import WhoConvertFetchTab from './WhoConvertFetchTab';

const { TabPane } = Tabs;

const WhoTabGroup = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const onConvertSuccess = useCallback(() => setRefreshKey(k => k + 1), []);

  return (
    <Tabs defaultActiveKey="comparison">
      <TabPane tab="Comparison" key="comparison">
        <WhoConvertFetchTab onConvertSuccess={onConvertSuccess} />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <WhoIndicatorMappingTab refreshTrigger={refreshKey} />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <WhoCountryMappingTab />
      </TabPane>
    </Tabs>
  );
};

export default WhoTabGroup;